/* User.ts */

export enum UserRoles {
  ADMIN = "admin",
  INSIGHTS_AGENT = "insights_agent",
}
